<template>
  <v-expansion-panel>
    <v-expansion-panel-header color="#007BC3">
      <template v-slot:actions>
        <v-icon color="white" class="font-weight-black"> icon-up-arrow </v-icon>
      </template>
      <b class="white--text">IDENTIFICAÇÃO DA EMPRESA</b>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-6">
      <v-row>
        <v-col cols="4">
          <BaseInputValidation
            disabled
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            id="employer_number"
            name="CPF/CNPJ *"
            rules="required"
            v-model="form.employer_number"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="5">
          <BaseInputValidation
            :disabled="view"
            id="company_name"
            name="Razão Social *"
            rules="required|max:100"
            v-model="form.company_name"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="5">
          <BaseInputValidation
            :disabled="view"
            id="trade_name"
            name="Nome Fantasia *"
            rules="required|max:100"
            v-model="form.trade_name"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="5">
          <validation-provider
            v-slot="{ errors }"
            name="Tipo de cliente/Fornecedor "
            rules="required"
          >
            <v-autocomplete
              :disabled="view"
              v-model="form.client_type_id"
              :items="clientTypes"
              item-text="description"
              item-value="id"
              outlined
              :error-messages="errors"
              label="Tipo de cliente / Fornecedor *"
            ></v-autocomplete>
          </validation-provider>
        </v-col>

        <v-col cols="2">
          <validation-provider
            v-slot="{ errors }"
            name="Classificação"
            rules="required"
          >
            <v-autocomplete
              :disabled="view"
              v-model="form.classification"
              :items="classifications"
              item-text="name"
              item-value="value"
              outlined
              :error-messages="errors"
              label="Classificação *"
            ></v-autocomplete>
          </validation-provider>
        </v-col>
        <v-col cols="4">
          <BaseInputValidation
            id="email"
            name="E-mail Primário *"
            rules="required|email|max:60"
            v-model="form.email"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="4">
          <BaseInputValidation
            id="email"
            name="E-mail Secundário"
            rules="email|max:60"
            v-model="form.secondary_email"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import BaseInputValidation from "../../../../components/UI/BaseInputValidation";
import { mask } from "vue-the-mask";
import { ValidationProvider } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
// import cloneDeep from "lodash/cloneDeep";

export default {
  props: { view: { type: Boolean, default: false } },
  name: "ProviderInfo",
  directives: { mask },
  data: () => ({
    form: {
      employer_number: "",
      email: "",
      company_name: "",
      trade_name: "",
      client_type_id: "",
      secondary_email: "",
      classification: ""
    },
    classifications: [
      {
        name: "Cliente",
        value: "client"
      },
      {
        name: "Fornecedor",
        value: "provider"
      },
      {
        name: "Ambos",
        value: "both"
      }
    ]
  }),
  components: {
    BaseInputValidation,
    ValidationProvider
  },
  computed: {
    ...mapGetters({
      clientTypes: "$_clientTypes/all",
      provider: "$_provider/provider"
    })
  },
  methods: {
    ...mapActions({
      clientTypesIndex: "$_clientTypes/index"
    })
  },
  created() {
    this.clientTypesIndex();
    Object.entries(this.form).forEach(element => {
      this.form[element[0]] = this.provider[element[0]];
    });
    this.form.client_type_id = parseInt(this.form.client_type_id);
  },

  watch: {
    form: {
      handler: function(newVal) {
        newVal.employer_number = newVal.employer_number.replace(/[^0-9]/g, "");
        this.$emit("setFields", {
          data: newVal
        });
      },
      deep: true
    }
  }
};
</script>

<style></style>
